import React from 'react';
import { toast } from 'react-toastify';
import { useUpdateGpsIntegration } from '@area-restrita/api-client/endpoints/gps-integrations/gps-integrations.gen';
import { GpsIntegrationsQueryData } from '@area-restrita/api-client/model/gpsIntegrationsQueryData';

import Dialog from '@/components/template/Dialog';

import EditGpsIntegrationForm from './EditGpsIntegrationForm';

interface EditGpsIntegrationModalProps {
  integration: GpsIntegrationsQueryData;
  trigger: React.ReactNode;
}

const EditGpsIntegrationModal: React.FC<EditGpsIntegrationModalProps> = ({
  integration,
  trigger,
}) => {
  const { mutateAsync: updateGpsIntegration, isPending } =
    useUpdateGpsIntegration();

  return (
    <Dialog
      title="Editar Integração GPS"
      description={`Edite a configuração da integração GPS #${integration.id}.`}
      trigger={trigger}
    >
      {({ handleClose }) => (
        <div className="py-4">
          <EditGpsIntegrationForm
            integration={integration}
            onSubmit={async (data) => {
              await updateGpsIntegration(
                {
                  id: integration.id,
                  data,
                },
                {
                  onSuccess: () => {
                    toast.success('Integração GPS atualizada com sucesso!');
                  },
                  onError: (error) => {
                    console.error('Erro ao atualizar integração GPS:', error);
                    toast.error(
                      'Erro ao atualizar integração GPS. Tente novamente.',
                    );
                  },
                },
              );
              handleClose();
            }}
            isLoading={isPending}
          />
        </div>
      )}
    </Dialog>
  );
};

export default EditGpsIntegrationModal;
